export const GLOBAL_NOTIFICATION_WRAPPER_MIN_HEIGHT = 56;
export const GlobalNotificationType = {
  ERROR: 'error',
  INFO: 'info',
  ATTENTION: 'attention',
  SUCCESS: 'success'
};